var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import SearchInput from '../SearchInput';
import { debounce } from '../TimingUtils';
import { LoadingIndicator } from '../LoadingIndicator';
import Alert from '@payscale/design/lib/alert';
import { Article } from './Article';
import './style/articleSearchFullPage.scss';
export class ArticleSearchFullPage extends React.Component {
    constructor(props) {
        super(props);
        this._minSearchTermLength = 4;
        const showArticle = this.props.articles.length === 1 ?
            this.props.articles[0].content : '';
        const showArticleHeader = this.props.articles.length === 1 ?
            this.props.articles[0].title : '';
        this.state = {
            isLoading: false,
            searchValue: '',
            showArticleHeader,
            hasSearched: false,
            showArticle,
            hasError: false
        };
        this.salesForceCallback = debounce(this.salesForceCallback.bind(this), 250);
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.goToArticle = this.goToArticle.bind(this);
        this.handleErrorBannerClose = this.handleErrorBannerClose.bind(this);
    }
    render() {
        const { logoPath } = this.props;
        return (React.createElement("div", { className: "article-search-full-page" },
            React.createElement("div", { className: "article-search-full-page__header" },
                logoPath && React.createElement("img", { src: logoPath, className: "payscale-logo", alt: "" }),
                React.createElement("div", { className: "article-search-full-page__header-content" },
                    React.createElement("h2", { className: "article-search-full-page__support-header" }, "Support help"),
                    React.createElement(SearchInput, { onChange: this.onChangeSearch, placeholderText: "Search Support Help" }))),
            this.state.hasError && this.renderErrorBanner(),
            React.createElement("div", { className: "suggested-articles" },
                (!this.state.isLoading &&
                    !this.state.showArticle &&
                    this.props.articles.length > 0) &&
                    React.createElement("div", { className: "suggested-articles__header" }, this.renderHeaderText()),
                this.renderListBody()),
            this.state.showArticle && !this.state.isLoading &&
                React.createElement("div", { className: "article-search-full-page__footer" },
                    React.createElement("p", { className: "article-search-full-page__footer-text" }, "Was this article helpful?"),
                    React.createElement("button", { className: "pxl-btn article-search-full-page__yes-btn" }, "Yes"),
                    React.createElement("button", { className: "pxl-btn article-search-full-page__no-btn" }, "No"))));
    }
    renderListBody() {
        const { searchImagePath } = this.props;
        if (this.state.isLoading) {
            return (React.createElement("div", { className: "suggested-articles__loading" },
                React.createElement(LoadingIndicator, null),
                React.createElement("div", { className: "suggested-articles__loading-text" }, "Searching Articles...")));
        }
        if (!this.props.articles.length && !this.state.isLoading && this.state.hasSearched) {
            return (React.createElement("div", { className: "suggested-articles__no-articles" },
                searchImagePath && React.createElement("img", { src: searchImagePath, className: "search-image", alt: "" }),
                React.createElement("h3", { className: "suggested-articles__no-articles-header" }, "No Articles Found"),
                React.createElement("div", { className: "suggested-articles__no-articles-body" }, "Try different keywords or more general keywords")));
        }
        if (this.state.showArticle) {
            return (React.createElement("div", { className: "salesforce-html" },
                React.createElement("h2", { className: "salesforce-html__header" }, this.state.showArticleHeader),
                React.createElement("div", { className: "salesforce-html__body", dangerouslySetInnerHTML: {
                        __html: this.state.showArticle
                    } })));
        }
        return (React.createElement("ul", { className: "suggested-articles__articles" }, this.props.articles.map(article => {
            return this.renderArticleLink(article);
        })));
    }
    renderArticleLink(article) {
        return (React.createElement(Article, { article: article, goToArticle: this.goToArticle, key: `article-${article.id}` }));
    }
    renderHeaderText() {
        const { showArticle } = this.state;
        const { articles } = this.props;
        if (articles.length && !showArticle) {
            return `Search Results (${articles.length})`;
        }
        return null;
    }
    renderErrorBanner() {
        return (React.createElement(Alert, { className: "article-search-full-page__error-banner", message: "Failed to sumbit the request. Please try again or refresh the page.", level: "danger", close: true, onClickClose: this.handleErrorBannerClose }));
    }
    onChangeSearch(value) {
        this.setState({ searchValue: value });
        if (value.length < this._minSearchTermLength) {
            return;
        }
        this.salesForceCallback(value);
    }
    salesForceCallback(value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoading: true });
            try {
                yield this.props.searchTermCallBack(value);
            }
            catch (_a) {
                this.setState({ hasError: true });
            }
            this.setState({ isLoading: false, hasSearched: true, showArticle: '', showArticleHeader: '' });
        });
    }
    goToArticle(id) {
        window.location.search = `id=${id}`;
    }
    handleErrorBannerClose() {
        this.setState({ hasSearched: false, hasError: false, searchValue: '' });
    }
}
export default { ArticleSearchFullPage };
